/* bca-disable */
import morphdom from 'morphdom';
// 接替v-html，做手动diff，防止图片多次卸载加载问题
export default Vue => {
    // 全局注册一个 v-html-morph 指令
    Vue.directive('html-morph', {
        // 绑定时先一次性插入
        bind(el, {value}) {
            el.innerHTML = value || '';
        },
        // 值变化时，只做局部 diff
        update(el, {value}) {
            // 注意 morphdom 接受的是两个节点，最外层标签要对上
            const newWrapper = el.cloneNode(true);
            newWrapper.innerHTML = value || '';
            morphdom(el, newWrapper, {
                onBeforeElUpdated: (fromEl, toEl) => {
                    // 如果是 img 且 src 没变，就跳过更新，保留旧的 DOM
                    if (
                        fromEl.tagName === 'IMG'
                        && fromEl.getAttribute('src') === toEl.getAttribute('src')
                    ) {
                        return false;
                    }
                    return true;
                },
            });
        },
    });
};